
export const calculateInvestmentValue = (
  birthYear: number,
  giftValue: number,
  investmentPercentage: number,
  targetAge: number,
  annualRate: number
): number => {
  const investableAmount = (giftValue * investmentPercentage) / 100;
  
  // Calculate compound interest from birth (age 0) to target age
  const yearsOfGrowth = targetAge;
  
  // Compound interest formula: A = P(1 + r)^t
  const futureValue = investableAmount * Math.pow(1 + annualRate, yearsOfGrowth);
  return Math.round(futureValue);
};

export const getCurrentAge = (birthYear: number): number => {
  const currentYear = new Date().getFullYear();
  return currentYear - birthYear;
};
